@if (actions['Assign Staff']) {
  <LOSx-client-assign-staff></LOSx-client-assign-staff>
}
@if (actions['Close']) {
  <LOSx-close-client></LOSx-close-client>
}
@if (actions['Survey']) {
  <LOSx-view-survey></LOSx-view-survey>
}
@if (actions['Reject']) {
  <LOSx-reject-client></LOSx-reject-client>
}
@if (actions['Activate']) {
  <LOSx-activate-client></LOSx-activate-client>
}
@if (actions['Withdraw']) {
  <LOSx-withdraw-client></LOSx-withdraw-client>
}
@if (actions['Update Default Savings']) {
  <LOSx-update-client-savings-account></LOSx-update-client-savings-account>
}
@if (actions['Transfer Client']) {
  <LOSx-transfer-client></LOSx-transfer-client>
}
@if (actions['Undo Transfer']) {
  <LOSx-undo-client-transfer></LOSx-undo-client-transfer>
}
@if (actions['Reject Transfer']) {
  <LOSx-reject-client-transfer></LOSx-reject-client-transfer>
}
@if (actions['Accept Transfer']) {
  <LOSx-accept-client-transfer></LOSx-accept-client-transfer>
}
@if (actions['Reactivate']) {
  <LOSx-reactivate-client></LOSx-reactivate-client>
}
@if (actions['Undo Rejection']) {
  <LOSx-undo-client-rejection></LOSx-undo-client-rejection>
}
@if (actions['Add Charge']) {
  <LOSx-add-client-charge></LOSx-add-client-charge>
}
@if (actions['Take Survey']) {
  <LOSx-take-survey></LOSx-take-survey>
}
@if (actions['Client Screen Reports']) {
  <LOSx-client-screen-reports></LOSx-client-screen-reports>
}
@if (actions['Create Collateral']) {
  <LOSx-add-client-collateral></LOSx-add-client-collateral>
}
